import { defaultTheme, RaThemeOptions } from 'react-admin';

export const darkTheme: RaThemeOptions = {
    ...defaultTheme,
    palette: {
      mode: 'dark',
      primary: {
        main: '#4b157c',
      },
      secondary: {
        main: '#b28c29',
      },
      background: {
        default: '#101213',
        paper: '#101213',
      },
      success: {
        main: '#24a891',
      },
      error: {
        main: '#e74852',
      },
      warning: {
        main: '#ca6c45',
      },
      info: {
        main: '#ffffff',
      },
      text: {
        primary: '#ffffff',
        secondary: '#95a1ac',
      },
    },
    components: {
      MuiLink: {
        styleOverrides: {
          root: {
            color: '#b28c29',
          },
        },
      },
      MuiAppBar: {
        styleOverrides: {
          root: {
            //backgroundImage: 'linear-gradient(rgba(255, 0, 255, 0.2), rgba(255, 0, 255, 0.1))',
            backgroundImage: 'radial-gradient(circle at 50% 14em,rgb(66, 8, 102) 0%,rgb(116, 20, 127) 40%,rgb(194, 155, 65) 100%)',

          },
        },
      },
        MuiPaper: { 
        styleOverrides: {
          root: {
            backgroundImage: 'linear-gradient(rgba(255, 255, 255, 0.05), rgba(255, 255, 255, 0.0))',
          },
        },
      },
      MuiButton: {
        styleOverrides: {
          outlined: {
            color: '#b28c29',
            borderColor: '#b28c29',
          },
          root: {
            color:'rgb(211, 172, 73)',
          },
          icon: {
            color: '#b28c29',
          },
        },
      },
      RaLogin: {
        styleOverrides: {
          root: {
            backgroundImage: 'radial-gradient(circle at 50% 14em,rgb(66, 8, 102) 0%,rgb(116, 20, 127) 40%,rgb(194, 155, 65) 100%)',
          },        
        },
      },        
      RaSidebarToggleButton: {
        styleOverrides: {
          root: {
            color: '#ffffff',
          },
        },
      },
      RaButton: {
        styleOverrides: {
          outlined: {
            color: '#b28c29',
            borderColor: '#b28c29',
          },
        },
      },
      RaDatagrid: {
        styleOverrides: {
          rowCell: {
            '& .RaDatagrid-rowCellIconButton': {
              color: '#b28c29',
            },
            '& .RaDatagrid-rowCellButton': {
              color: '#b28c29',
            },
            '& .RaDatagrid-rowCellLink': {
              color: '#b28c29',
            },
          },
        },
      },
    },
  };